(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-to-element-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const link = document.querySelectorAll('.scrollToELement');

    link.forEach(element => {
      element.addEventListener('click', function(event) {
      event.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const target = document.getElementById(targetId);

      if (target) {
        const headerOffset = document.documentElement.style.getPropertyValue('--header-height-unitless');
        const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
        const scrollToY = targetTop - (window.innerHeight / 2) + (target.offsetHeight / 2) - 300;

        window.scrollTo({
          top: scrollToY,
          behavior: 'smooth'
        });
      }
    });
    });

 
  });
  } catch(e) { console.error(e); }
})();

})();
